"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FileUploadList;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const List_1 = __importDefault(require("../components/List"));
const FileUpload_1 = __importDefault(require("../components/FileUpload"));
const Loading_1 = __importDefault(require("../components/Loading"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        field: {
            flexDirection: (size != 'sm' ? 'row' : 'column'),
            alignItems: (size != 'sm' ? 'center' : 'flex-start')
        },
        fieldLabel: {
            backgroundColor: (true ? THEME.SmokeWhite : null),
            borderRadius: 4,
            paddingVertical: 2,
            paddingHorizontal: (true ? 4 : null),
            marginRight: 4,
            marginBottom: (size != 'sm' ? -1 : 2)
        },
        fieldLabelText: {
            color: THEME.SmokeWhiteText,
            fontSize: (size != 'sm' ? 12 : 10)
        },
        fieldText: {
            fontSize: (size != 'sm' ? 14 : 12),
            color: THEME.Text
        }
    });
};
function FileUploadList(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const styles = useStyles();
    const element = react_1.default.useRef(null);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [files, setFiles] = react_1.default.useState(null);
    const error = react_1.default.useCallback((error) => {
        let message = t('company:messages.uploadError');
        if (error == 400)
            message = t('company:messages.uploadErrorType');
        react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message });
    }, []);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(props.getFileList?.()).then(data => {
            setFiles(data);
            setStatus('done');
        }).catch(e => {
            setFiles(null);
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { ref: element, style: props.style, children: [(0, jsx_runtime_1.jsx)(FileUpload_1.default, { disabled: props.disabled || status == 'loading', buttonText: t('common:buttons.upload'), waitingText: t('common:text.pleaseWait'), extensions: props.extensions, mimeTypes: props.mimeTypes, utiTypes: props.utiTypes, getUploadUrl: props.getUploadUrl, onUploaded: refresh, onError: error, style: { marginBottom: 4 } }), (status == 'done')
                &&
                    (0, jsx_runtime_1.jsx)(List_1.default, { data: files, keyExtractor: (item, index) => 'file' + index, itemSeparator: () => (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator] }), listEmpty: () => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingVertical: (size != 'sm' ? 36 : 24),
                                paddingHorizontal: (size != 'sm' ? 24 : 12),
                                opacity: 0.5
                            }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Text, icon: Theme_1.ICONS.Light.FileLines, size: 20, style: {
                                        marginRight: (size != 'sm' ? 12 : 8),
                                        pointerEvents: 'none'
                                    } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                        color: THEME.Text,
                                        fontSize: (size != 'sm' ? 18 : 16)
                                    }, children: t('company:messages.noFilesUploaded') })] })), renderItem: (item, index) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingVertical: (size != 'sm' ? 16 : 12),
                                paddingHorizontal: (size != 'sm' ? 12 : 0)
                            }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Light.FileLines, size: 30, style: {
                                        marginRight: (size != 'sm' ? 16 : 12),
                                        pointerEvents: 'none'
                                    } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                    fontSize: (size != 'sm' ? 16 : 14),
                                                    color: THEME.Text,
                                                    fontWeight: '500'
                                                }, children: item.name }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.field, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.fieldLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.fieldLabelText, children: "Date" }) }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.fieldText, children: item.date })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.field, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.fieldLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.fieldLabelText, children: "Type" }) }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.fieldText, children: item.type })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.field, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.fieldLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.fieldLabelText, children: "Size" }) }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.fieldText, children: item.size })] })] })] })] })) })
                ||
                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { minHeight: 64 }, children: (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) })] }));
}
